/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_StandingsInputs */

const th_nav_standings = /** @type {(inputs: Nav_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตารางคะแนน`)
};

const en_nav_standings = /** @type {(inputs: Nav_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standings`)
};

const ja_nav_standings = /** @type {(inputs: Nav_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`順位表`)
};

const zh_nav_standings = /** @type {(inputs: Nav_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`积分榜`)
};

const es_nav_standings = /** @type {(inputs: Nav_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clasificación`)
};

const pt_nav_standings = /** @type {(inputs: Nav_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificação`)
};

const id_nav_standings = /** @type {(inputs: Nav_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klasemen`)
};

const fr_nav_standings = /** @type {(inputs: Nav_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classement`)
};

const tl_nav_standings = /** @type {(inputs: Nav_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talaan`)
};

const vi_nav_standings = /** @type {(inputs: Nav_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bảng xếp hạng`)
};

const ko_nav_standings = /** @type {(inputs: Nav_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`순위`)
};

const de_nav_standings = /** @type {(inputs: Nav_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabelle`)
};

const ru_nav_standings = /** @type {(inputs: Nav_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Таблица`)
};

const tr_nav_standings = /** @type {(inputs: Nav_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puan durumu`)
};

const it_nav_standings = /** @type {(inputs: Nav_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classifica`)
};

const pl_nav_standings = /** @type {(inputs: Nav_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabela`)
};

const uk_nav_standings = /** @type {(inputs: Nav_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Таблиця`)
};

const hi_nav_standings = /** @type {(inputs: Nav_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंक तालिका`)
};

const ar_nav_standings = /** @type {(inputs: Nav_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الترتيب`)
};

const ms_nav_standings = /** @type {(inputs: Nav_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kedudukan`)
};

const bn_nav_standings = /** @type {(inputs: Nav_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পয়েন্ট তালিকা`)
};

const zh_tw2_nav_standings = /** @type {(inputs: Nav_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`積分榜`)
};

const zh_hk2_nav_standings = /** @type {(inputs: Nav_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`積分榜`)
};

const ur_nav_standings = /** @type {(inputs: Nav_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پوائنٹس ٹیبل`)
};

const fa_nav_standings = /** @type {(inputs: Nav_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جدول`)
};

const sw_nav_standings = /** @type {(inputs: Nav_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Msimamo`)
};

const nl_nav_standings = /** @type {(inputs: Nav_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stand`)
};

/**
* | output |
* | --- |
* | "Standings" |
*
* @param {Nav_StandingsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const nav_standings = /** @type {((inputs?: Nav_StandingsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_StandingsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_nav_standings(inputs)
	if (locale === "ja") return ja_nav_standings(inputs)
	if (locale === "zh") return zh_nav_standings(inputs)
	if (locale === "es") return es_nav_standings(inputs)
	if (locale === "pt") return pt_nav_standings(inputs)
	if (locale === "id") return id_nav_standings(inputs)
	if (locale === "fr") return fr_nav_standings(inputs)
	if (locale === "tl") return tl_nav_standings(inputs)
	if (locale === "vi") return vi_nav_standings(inputs)
	if (locale === "ko") return ko_nav_standings(inputs)
	if (locale === "de") return de_nav_standings(inputs)
	if (locale === "ru") return ru_nav_standings(inputs)
	if (locale === "tr") return tr_nav_standings(inputs)
	if (locale === "it") return it_nav_standings(inputs)
	if (locale === "pl") return pl_nav_standings(inputs)
	if (locale === "uk") return uk_nav_standings(inputs)
	if (locale === "hi") return hi_nav_standings(inputs)
	if (locale === "ar") return ar_nav_standings(inputs)
	if (locale === "ms") return ms_nav_standings(inputs)
	if (locale === "bn") return bn_nav_standings(inputs)
	if (locale === "zh-TW") return zh_tw2_nav_standings(inputs)
	if (locale === "zh-HK") return zh_hk2_nav_standings(inputs)
	if (locale === "ur") return ur_nav_standings(inputs)
	if (locale === "fa") return fa_nav_standings(inputs)
	if (locale === "sw") return sw_nav_standings(inputs)
	if (locale === "nl") return nl_nav_standings(inputs)
	return en_nav_standings(inputs)
});